export default {
  name: 'CommonPickerCpt',
  components: {},
  props: {
    request: {
      type: [Object, Function],
      require: true
    },
    requestParameter: {
      type: [Object],
      default() {
        return {};
      }
    },
    columnsFieldNames: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      showPicker: false,
      isLoading: false,
      columns: []
    };
  },
  methods: {
    showView() {
      this.showPicker = true;
      this.isLoading = true;
      let that = this;
      this.request(this.requestParameter).then(res => {
        const resData = res.data.data;
        this.columns = resData;
      }).finally(() => {
        that.isLoading = false;
      });
    },
    onConfirmClick({
      selectedValues,
      selectedOptions
    }) {
      this.$emit('onSelectedChange', selectedValues, selectedOptions);
      this.showPicker = false;
    },
    onCancelClick() {
      this.showPicker = false;
    }
  }
};